import styled from 'styled-components';

export const TextColorButtonPickerStyled = styled.div`
  width: 160px;

  .color-button {
    border: none;
    border-radius: 0;
    height: 20px;
    padding: 0;
    width: 20px;

    &:hover {
      border: 1px solid black;
    }
  }
`;
